import { toJS } from 'mobx'

export const deepToJS = obj => toJS(obj, { recurseEverything: true })
